@if (enabled) {
  <button
    class="transparent-btn"
    (click)="openModal()"
    [disabled]="!proposal"
    ngbTooltip="Insérer la police"
    i18n-ngbTooltip
  >
    <app-arrow-right-icon width="16px" height="16px" color="var(--brand-500)" />
  </button>

  <app-action-modal
    #actionModal
    [disabled]="submitted"
    [submitDisabled]="submitDisabled"
    [showHeader]="true"
    submitButtonClass="lty-btn-primary"
    size="md"
    headerIconState="success"
    (submitted)="addPolicy()"
    (cancelled)="resetFormState()"
  >
    <div class="d-flex justify-content-center align-items-center" headerIcon>
      <app-send-icon width="16px" height="16px" color="var(--success-500)" />
    </div>

    <ng-container mainTitle i18n>Insérer la police</ng-container>

    <ng-container subtitle>
      <form class="lty-form mt-12" [formGroup]="policyFormGroup">
        <div class="form-group mb-16">
          <label for="policyId" i18n>N° de police</label>
          <input
            class="form-control"
            type="text"
            id="policyId"
            formControlName="policyId"
          />
        </div>

        <label class="file-label mb-8" for="create-policy-file-upload" i18n
          >Document police</label
        >
        <div class="form-group mb-32">
          <div class="file alternate">
            <input type="file" (change)="onFileUpload($event)" multiple />
            <div class="upload-icon">
              <app-upload-cloud-icon
                height="20px"
                width="20px"
                color="var(--gray-600)"
              />
            </div>
            <span
              ><span class="highlighted-text" i18n
                >Cliquez pour télécharger
              </span>
              <ng-container i18n>ou glissez un fichier</ng-container></span
            >
          </div>

          @if (uploadedFiles.length > 0) {
            <div class="mt-12">
              @for (
                uploadedFile of uploadedFiles;
                track uploadedFile.name + uploadedFile.size;
                let idx = $index
              ) {
                <div class="uploaded-file-container mb-8">
                  <div class="uploaded-file-element">
                    <app-file-icon
                      height="20px"
                      width="20px"
                      color="var(--gray-400)"
                    />
                    <div class="file-name">
                      <span>{{ uploadedFile.name }}</span>
                      <span>{{ uploadedFile.size | fileSize: 1 }}</span>
                    </div>
                    <app-check-circle-icon
                      height="16px"
                      width="16px"
                      color="var(--success-500)"
                    />
                  </div>
                  <button
                    type="button"
                    class="transparent-btn"
                    (click)="removeFile(idx)"
                  >
                    <app-trash-icon
                      height="24px"
                      width="24px"
                      color="var(--gray-400)"
                    />
                  </button>
                </div>
              }
            </div>
          }
        </div>
      </form>
    </ng-container>

    <ng-container submitButtonLabel i18n>Confirmer</ng-container>
  </app-action-modal>
}
